import { AxiosError } from 'axios'
import { toast } from 'react-toastify'

import { createDatasetStepsAction } from '../../actions/ai';

type CreateStepsProps = {
  filename: string
  createDatasetStepsUrl?: string
  messages: any[]
  setMessages: React.Dispatch<React.SetStateAction<any[]>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  setshowSteps: React.Dispatch<React.SetStateAction<boolean>>
};

const createSteps = async ({
  filename,
  createDatasetStepsUrl,
  messages,
  setMessages,
  setLoading,
  setshowSteps
}: CreateStepsProps ) => {
  try {
    setMessages((prevMessages) => [...prevMessages, 'Step by Step Instructions']);
    setLoading(true);

    const formattedFilename = filename.replace(/ /g, '_')
    const result = await createDatasetStepsAction(
      formattedFilename, 
      {
        prompt: messages[messages.length - 2] || "",
        answer: messages[messages.length - 1]?.message || "",
        chat_memory: messages,
      }, 
      createDatasetStepsUrl
    );
    
    setMessages((prevMessages) => [...prevMessages, result || result.message]);
    setshowSteps(false);
  } catch (err) {
    if (err instanceof AxiosError) {
      toast.error(err.response?.data.message ?? err.message);
    }
    return Promise.reject(err);
  } finally {
    setLoading(false);
  }
}

export default createSteps;